import React from 'react'

import { TradingPoolActive } from '@pages/RewardsHub/components/TradingPoolActive'
import { TradingPoolPending } from '@pages/RewardsHub/components/TradingPoolPending'

import { TradingPoolCampaignStatus, TradingPoolTypeDto } from '@model/RewardsHubDashboardDto'

export const TradingPoolProgress: React.FC<{
  campaign: TradingPoolTypeDto
}> = ({ campaign }) => {
  if (campaign.status.id === TradingPoolCampaignStatus.ACTIVE) {
    return <TradingPoolActive campaign={campaign} />
  } else if (
    campaign.status.id === TradingPoolCampaignStatus.ENDED_DRAW_PENDING ||
    campaign.status.id === TradingPoolCampaignStatus.ENDED
  ) {
    return <TradingPoolPending campaign={campaign} />
  } else {
    return <></>
  }
}
